import { PropTypes } from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { CustomLink } from '../../../common/CustomLink'
import { Element } from '../../../common/html/element'
import classes from './index.module.scss'
import { MainContent } from './mainContent'
import { NextButton } from './NextButton'
import { SideContent } from './sideContent'

export const SelectCriteria = ({ navigateToExportScreen }) => {
  return (
    <Element className={classes.screening}>
      <Element className="dFlex justifyContentBetween alignItemsCenter py2">
        <Element
          className={classes.screenName}
          style={{ color: '#0553A5', fontSize: 24 }}
        >
          <Translate value="screening.SCREENING" />
        </Element>
        <Element
          elementName="button"
          className={classes.criteriaBtn}
          style={{
            color: '#2C73E8',
            borderColor: '#9FC3FF',
          }}
        >
          <CustomLink to="/screening/savedCriteria">
            <Translate value="screening.ALL_SAVED_CRITERIA" />
          </CustomLink>
        </Element>
      </Element>

      <Element className={classes.content} style={{ borderColor: '#D5D5D5' }}>
        <SideContent />
        <MainContent />
      </Element>

      <NextButton navigateToExportScreen={navigateToExportScreen} />
    </Element>
  )
}

SelectCriteria.propTypes = {
  navigateToExportScreen: PropTypes.func.isRequired,
}
